export default __webpack_public_path__ + "images/noimage-placeholder.e03afb52326346fb5aaaac9c9b483767.png";